import React, { useEffect, useState } from "react";
import { RiMenuLine } from "react-icons/ri";
import { FaBell } from "react-icons/fa";
import { MdMail, MdSearch, MdPeople } from "react-icons/md";
import Config from "../axios/Config";
import Cookies from "js-cookie";
import { AxiosCustomGet } from "../axios/AxiosCustom";
import { capitalize } from "../helpers";
import { Link } from "react-router-dom";
import { Modal, Button, Divider } from "antd";
import convertTime from "../helpers/convertTime";
import InfiniteScroll from "react-infinite-scroll-component";

const Navbar = (props) => {
  const [fullName, setFullName] = useState("");
  const [jabatan, setJabatan] = useState("");
  const [id, setId] = useState();
  const [modalNotification, setModalNotification] = useState(false);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = () => {
    const url = `${process.env.REACT_APP_BASE_API_URL}self`;

    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        let data = response.data.data;
        setId(data.employee.id);
        setFullName(
          `${capitalize(data.employee.first_name)} ${capitalize(
            data.employee.last_name
          )}`
        );
        setJabatan(capitalize(data.employee.jabatan.name));
      }
    );
  };

  const handleCloseModal = () => {
    setModalNotification(false);
  };

  const handleSelect = (item) => {
    props.handleSelectNotif(item);
  };
  const handleOpenModal = () => {
    props.getDataNotification();
    setModalNotification(true);
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bgc-F9F9F9 border-bottom"
      style={{ height: "5rem" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: 26,
              height: 26,
              background: "#2C465C",
              borderRadius: 8,
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
              marginRight: 10,
              cursor: "pointer",
            }}
          >
            <RiMenuLine style={{ fontSize: 18, color: "#fff" }} />
          </div>
          <MdSearch style={{ ...styles.icons, marginRight: -30, zIndex: 1 }} />
          <input
            style={{
              borderRadius: 33,
              paddingLeft: 30,
              width: 392,
              background: "#EFEFEF",
              border: "none",
            }}
            className="form-control"
            type="text"
            placeholder="Cari..."
          ></input>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FaBell style={styles.icons} onClick={handleOpenModal} />
          <div className="numberNotification">{props.totalNotif}</div>
          <Link to={{ pathname: `/view_employee/${id}` }}>
            <div
              style={{
                ...styles.icons,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "50%",
                  background: "#C4C4C4",
                  width: 24,
                  height: 24,
                }}
              ></div>
              <div style={{ marginLeft: 8 }}>
                <div style={{ fontSize: 14, color: "#303030", margin: 0 }}>
                  {fullName}
                </div>
                <div style={{ color: "#A6A6A6", fontSize: 10, margin: 0 }}>
                  {jabatan}
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <Modal
        bodyStyle={{ overflowY: "hidden" }}
        closeIcon={<div />}
        style={{
          top: "8%",
          left: "0%",
          marginRight: "0%",
        }}
        width={"25%"}
        mask={false}
        visible={modalNotification}
        onCancel={handleCloseModal}
        footer={
          props.selectedNotif.length > 0
            ? [
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  onClick={props.handleButtonFooterNotification}
                  key="back"
                >
                  Tandai Sudah Dibaca
                </Button>
              </div>,
            ]
            : null
        }
      >
        <InfiniteScroll
          height={500}
          dataLength={props.dataNotification.length}
          next={props.getMoreNotification}
          hasMore={props.hasMore}
          loader={props.dataNotification.length > 10 && <h3> Loading...</h3>}
          endMessage={<h4>Nothing more to show</h4>}
          scrollableTarget="scrollableDiv"
          useWindow={false}
        >
          <div id="scrollableDiv">
            {props.dataNotification.map((item, index) => {
              return (
                <div
                  onClick={() => handleSelect(item)}
                  className="my-1 py-2 item-notification"
                  style={{
                    borderRadius: 6,
                    backgroundColor: item.selected ? "#dcdcdc" : null,
                  }}
                  key={index}
                >
                  {/* <Divider /> */}
                  <div
                    role="button"
                    className="d-flex justify-content-between mx-1"
                  >
                    <MdPeople size={20} color="#2C465C" />
                    <div className="d-flex" style={{ flex: 3 }}>
                      <div>
                        <div className="text-capitalize ml-2">{item.title}</div>
                        <div className="color-A6A6A6 ml-2">{item.notes}</div>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="color-A6A6A6 align-self-end">
                        {convertTime(item.created_at)}
                      </div>
                      {buttonNotif(item.title)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </InfiniteScroll>
      </Modal>
    </nav>
  );
};

export default Navbar;

const styles = {
  icons: {
    color: "#2C465C",
    fontSize: 24,
    margin: "32px 12px",
    cursor: "pointer",
  },
};

const buttonNotif = (key) => {
  if (key === "TELAH  DITRANSFER") {
    return <ButtonAction text="Diterima" />;
  }
};

const ButtonAction = ({ text }) => {
  return (
    <Button
      variant="primary"
      className="btn-action btn-add"
      style={{
        borderRadius: 6,
        paddingVertical: 2.5,
        paddingHorizontal: 9,
        color: "#fff",
      }}
    >
      {text}
    </Button>
  );
};
